import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1abc1fd0")

_pushScopeId("data-v-1abc1fd0")
const _hoisted_1 = { class: "pay-processing" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextPayProgressing) + " ", 1),
    _createVNode("p", {
      class: "pay-jump",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.payJump && _ctx.payJump(...args)))
    }, _toDisplayString(_ctx.$wordList.ProperAllTextPayJump), 1)
  ]))
})